import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";import { Toaster } from "sonner";
import "@/App.css";
import Showroom from "@/pages/Showroom";

function App() {
  return (
    <div className="App font-body text-slate-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/showroom" replace />} />
          <Route path="/showroom" element={<Showroom />} />
          {/* legacy redirects */}
          <Route path="/design" element={<Navigate to="/showroom" replace />} />
          <Route path="/design/:id" element={<Navigate to="/showroom" replace />} />
          <Route path="/embed" element={<Showroom embed />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
